import { makeStyles } from '@material-ui/core';

import { colorTheme, neutral } from 'shared/styles/colors';

export default makeStyles({
  root: {
    backgroundColor: colorTheme.brand.primary.light,
    '&[data-has-substitution-flow="true"]': {
      color: neutral[60],
      backgroundColor: neutral.white,
      border: `1px solid ${neutral[20]}`,
    },
  },
});
